import { render, staticRenderFns } from "./ComponentEducationBottom.vue?vue&type=template&id=282a82d8&scoped=true&"
import script from "./ComponentEducationBottom.vue?vue&type=script&lang=js&"
export * from "./ComponentEducationBottom.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEducationBottom.vue?vue&type=style&index=0&id=282a82d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282a82d8",
  null
  
)

export default component.exports